var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegacyChallengeProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.361 37.8657C74.7424 36.4844 72.8298 36.5907 72.511 35.5281C77.2926 37.0157 81.8616 34.4655 86.537 35.8469C86.962 37.972 85.5806 38.6095 84.093 38.9283C80.499 39.8055 76.7133 39.4307 73.361 37.8657V37.8657Z",
    fill: "#FE7C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5665 21.5021C60.0789 18.6332 61.9915 16.083 61.9915 13.4266C61.9463 12.9954 62.0341 12.5607 62.243 12.1809C62.4519 11.801 62.772 11.4941 63.1603 11.3014C64.7542 10.6639 65.498 10.9826 66.0293 12.789C66.5606 14.5954 65.6043 18.3144 64.4354 20.7583C63.2666 23.2022 62.5228 21.3959 61.5665 21.5021Z",
    fill: "#FE7C1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1923 26.2837C72.2985 25.6462 73.3611 25.8587 73.0423 25.2211C72.7236 24.5836 73.5736 23.4148 74.4237 22.9897C75.2737 22.5647 77.7176 19.802 80.2678 20.6521C81.1179 20.8646 81.5429 21.5021 81.0116 22.2459C80.4803 22.9897 77.1864 25.0086 75.1675 26.39C73.1486 27.7713 73.2548 26.4962 72.1923 26.2837Z",
    fill: "#FE7C1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 60.068H64.041C64.6035 60.0678 65.1542 59.9091 65.6288 59.6104C66.1034 59.3118 66.4821 58.8856 66.7206 58.3817C66.9591 57.8779 67.0476 57.3172 66.9757 56.7654C66.9037 56.2136 66.6743 55.6935 66.3144 55.266L55.5605 44.5685L66.3144 33.871C66.6743 33.4435 66.9037 32.9234 66.9757 32.3716C67.0476 31.8198 66.9591 31.2591 66.7206 30.7553C66.4821 30.2514 66.1034 29.8252 65.6288 29.5265C65.1542 29.2279 64.6035 29.0692 64.041 29.069H23V60.068ZM23 60.068V84",
    stroke: "#00525E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacyChallengeProjectIcon);
export default __webpack_public_path__ + "static/media/legacy_challenge_project_icon.02f51dd9e3d46d4c72249c7ea3883ad5.svg";
export { ForwardRef as ReactComponent };